import { useNav } from '../state/NavContext';
import { overall } from '../state/statsLogic';
import { useStats } from '../state/StatsContext';
import { useProfile } from '../state/ProfileContext';
import { useSettings } from '../state/SettingsContext';
import { Avatar } from './Avatar';
import { IconButton } from './Button';

function BrandMark() {
  return (
    <svg className="cv-brand__mark" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <path d="M16 28V12" stroke="var(--vine)" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M15 18C9 17 6 13 6 8c5 0 9 3 9 10Z" fill="var(--vine)" />
      <path d="M17 14c6-1 9-5 9-10-5 0-9 4-9 10Z" fill="var(--vine-bright)" />
      <circle cx="16" cy="29" r="2" fill="var(--seed)" />
    </svg>
  );
}

export function TopBar() {
  const { route, navigate } = useNav();
  const { stats } = useStats();
  const { profile } = useProfile();
  const { resolvedTheme, update } = useSettings();
  const o = overall(stats);

  return (
    <header className="cv-topbar">
      <div className="cv-topbar__identity">
        <button className="cv-brand" onClick={() => navigate('home')} aria-label="ClueVine — home">
          <BrandMark />
          <span className="cv-brand__word">
            Clue<em>Vine</em>
          </span>
        </button>
        {o.currentBestStreak > 0 ? (
          <span className="cv-streak-pill" title="Best current daily streak">
            <Avatar id={profile?.avatar ?? 'sprout'} size={20} />
            {o.currentBestStreak}
          </span>
        ) : null}
      </div>

      <div className="cv-topbar__actions">
        <IconButton
          icon="help"
          label="How to play"
          aria-pressed={route.screen === 'howto'}
          onClick={() => navigate('howto')}
        />
        <IconButton
          icon="chart"
          label="Stats"
          aria-pressed={route.screen === 'stats'}
          onClick={() => navigate('stats')}
        />
        <IconButton
          icon="history"
          label="History"
          aria-pressed={route.screen === 'history'}
          onClick={() => navigate('history')}
        />
        <IconButton
          icon="gear"
          label="Settings"
          aria-pressed={route.screen === 'settings'}
          onClick={() => navigate('settings')}
        />
        <IconButton
          icon={resolvedTheme === 'dark' ? 'sun' : 'moon'}
          label={resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={() => update({ theme: resolvedTheme === 'dark' ? 'light' : 'dark' })}
        />
      </div>
    </header>
  );
}
